import { Badge, Box, Group, Stack, Text } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { DATA_FILE_TYPES } from '../../../../common/enums/enums';
import { NavLink } from 'react-router-dom';

const NameCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const badgeColor = getEnumColor(DATA_FILE_TYPES, rowData.type);
    const badgeLabel = getEnumLabel(DATA_FILE_TYPES, rowData.type);
    return (
        <Group gap={'xs'}>
            <Text>{rowData.name}</Text>
            <Badge
                size={'sm'}
                color={badgeColor}>
                {badgeLabel}
            </Badge>
        </Group>
    );
};

const NameColumn = () => ({
    accessorKey: 'name',
    header: 'Name',
    size: 1,
    Cell: ({ cell }) => <NameCell cell={cell} />,
});
export default NameColumn;
